export default "__VITE_ASSET__C9TUJ34V__"